// extracted by mini-css-extract-plugin
module.exports = {"label":"AddAllocationPlan_label_3Qa6Z","err_msg":"AddAllocationPlan_err_msg_aiiow","left":"AddAllocationPlan_left_31lf4","right":"AddAllocationPlan_right_5VAqr"};